module.exports = __webpack_public_path__ + "static/media/200512-artwork-fashion-slashie-eva.e8e7924e.jpg";